import i18n, { InitOptions } from 'i18next'
import translationDE from './locales/de/translation.json'
import translationEN from './locales/en/translation.json'
import translationFR from './locales/fr/translation.json'

const commonI18props: InitOptions = {
  supportedLngs: ['en', 'de', 'fr'],
  fallbackLng: 'en',
  load: 'languageOnly',
  nsSeparator: false,
  keySeparator: '::',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
}

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  fr: {
    translation: translationFR,
  },
}
// @ts-ignore
i18n
  .init({
    resources,
    ...commonI18props,
    react: {
      useSuspense: true,
      wait: true,
    },
  })

export default i18n
